import {OggettoConfig} from "../../../app/shared/_services/dynamic-crud.service";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {generateExcel} from "../../Utility/Utility";
import {Scaduta} from "../../Utility/DateUtility";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {CouponTypeObject} from "./SanPellegrino";

export function Coupon() {
  var OBJ: OggettoConfig = {
    Id: "coupon",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 50},
    ListResponseHasData: true,
    listTitle: "Coupon",
    HasAddList: {},
    AzioniLista:[
      {
        nome: '',
        parameterInArray: true,

        class: 'btn link font-16 text-danger font-medium mr-2',
        type: 'POST',
        restRoute: '/prodotti/delete',
        icon: 'fas fa-trash text-danger',
        successMex: "Eliminazione Riuscita",
        parameter: [{ nome: "id", parameter: 'id' }]
      },
    ],
    Buttons: [{
      nome: 'Import',//codice coupon, valore, codice adhoc prodotto, tipo, datascdenza1, datascadenza2
      icon: 'fas fa-upload',
      class: "btn btn-cyan p-2",
      func: (x: any[], api: ApiPathsService, end: () => void, toastService: ToastrService) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = () => {
          const file = input.files?.[0];
          if (!file) {
            toastService.error('Nessun file selezionato');
            return;
          }
          const formData = new FormData();
          formData.append('allegato', file);
          api.MultipartSendRequest(formData, api.getBaseAPI() + "/prodotti/import/coupon", true, 0, end)
        };
        input.click();
      }
    }, {
      nome: "Scarica il Template",
      icon: 'fas fa-download',
      class: "btn btn-cyan p-2",
      func: () => {
        generateExcel([['codice coupon', 'valore', 'codice adhoc prodotto','tipo (SI,SO,OM)', 'datascdenza1', 'datascadenza2'], ['codice coupon', 'valore', 'codice adhoc prodotto','tipo (SI,SO,OM)', 'datascdenza1', 'datascadenza2'], ['codice coupon', 'valore', 'codice adhoc prodotto','tipo (SI,SO,OM)', 'datascdenza1', 'datascadenza2'], ['codice coupon', 'valore', 'codice adhoc prodotto','tipo (SI,SO,OM)', 'datascdenza1', 'datascadenza2']])
      }
    }
    ],
    ListMap: (list) => list.map(coupon => {
      return {...coupon, dataScadenza: Scaduta(coupon.dataScadenza1) ? coupon.dataScadenza2 : coupon.dataScadenza1}
    }),
    Map: (x) => {
      return {...x, prezzo: x.prezzi?.length ? x.prezzi[0].prezzo : 0}
    },
    OnSaveMap: (x) => {
      return {...x, prezzi: [{um: 64, prezzo: CouponTypeObject(x).prezzo, iva: 22,}],prezzo:CouponTypeObject(x).prezzo, tipo: 50}
    },
    Headers: [
      CampoAggiuntivo.InputField("Codice", "prodotto", "text", "", {modificabile: false, printable:false}),
      CampoAggiuntivo.InputField("Valore", "prezzo", "euro", "", {modificabile: false, printable:false}),
      CampoAggiuntivo.InputField("Data di scadenza", "dataScadenza", "date", "", {modificabile: false, printable:false}),
      {nome: "Prodotto", oggetti: ['correlatiObject'], type: 'objArray', field: ['prodotto'], printable:false}
    ],
    campi: [
      CampoAggiuntivo.InputField("Codice", "prodotto","text",'col-lg-3',{required:true}),
      // CampoAggiuntivo.InputField("Valore", "prezzo", "euro"),
      CampoAggiuntivo.InputField("Data di scadenza 1", "dataScadenza1", "date",'col-lg-3',{required:true}),
      CampoAggiuntivo.InputField("Data di scadenza 2", "dataScadenza2", "date",'col-lg-3',{required:true}),
      CampoAggiuntivo.SingleDropdown("Tipo", "posizione", "/prodotti/coupon/tipi","label",{required:true}),
      CampoAggiuntivo.SingleDropdown("Prodotto", "correlati", "/prodotti/list", "prodotto", {
        responseHasData: true,
        required:true,
        parameter: [{nome: 'page', value: 1}, {nome: 'size', value: 5}, {nome: 'tipo', value: 68}, {
          nome: "prodotto",
          search: true
        }]
      }, 'col-lg-3', () => true, {singleOutput: false })
    ],
    MenuItems: [
      {
        path: "/sanpellegrino/shared/dynamiclist/coupon",
        title: "Coupon",
        icon: "fa-solid fa-receipt",
        class: "",
        capacita: ['gestione-prodotti'],
      },
    ]
  }
  return OBJ;
}
